import React, { useEffect, useState } from "react";
import { useAlert } from "react-alert";
import {
  Col,
  Container,
  Row,
  Table,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Button,
  DropdownToggle,
  UncontrolledDropdown,
  DropdownItem,
  DropdownMenu,
} from "reactstrap";
import Layout from "../../../components/Layout";
import { PageBody } from "../../../components/Loader";
import { RouteComponentProps, useParams } from "react-router-dom";
import classnames from "classnames";
import { useLoadingMessage } from "../../../components/useLoadingMessage";
import { useWarehouse } from "./WarehouseContext";
import { seasonService } from "../../../Services";
import { configService } from "../../../Services";
import {
  WarehouseInventoryItem,
  PurchaseOrderData,
  PurchaseOrderResponseModel,
  InputDelivery,
  Distribution,
  PaginationSecondMeta,
} from "../../../models/config.model";
import InputDistribution from "../../dashbaord/season/manage season/states/Input_distribution";
import InputDeliveries from "../../dashbaord/season/manage season/states/Input_delivery";
import ViewDelivery from "../../dashbaord/season/manage season/states/View_delivery";
import WInputDeliveries from "../../dashbaord/season/manage season/states/W_input_delivery";
import {
  getWarehousesWithState,
  getInputDistributionByState,
 
} from "../../dashbaord/season/manage season/states/dataFetchingFunctions";
import { HiDotsVertical } from "react-icons/hi";
import { useCluster } from "./manage season/states/ClusterContext";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../redux/store/rootReducer";
import { seasonThunk } from "../../../redux/action/season/season.thunk";
import { Dispatch } from "redux";
interface WarehouseData {
  uniqueId: string;
  "werehouse name": string;
  address: string;
  lga: string;
  "warehouse state": string;
}

interface RouteParams {
  stateId: string;
  uniqueId: string;
}

const ManageWarehouse = ({ match }: RouteComponentProps<RouteParams>) => {
  const dispatch = useDispatch();
  const { isLoading, message, updateLoader } = useLoadingMessage();
  const [currentActiveTab, setCurrentActiveTab] = useState("1");
  const alert = useAlert();
  const {
    stateCluster,
    error,
    loading: clusterLoading,
    fetchClustersData,
    refreshClusters,
    currentSeasonId,
    currentStateId,
  } = useCluster();

  const { stateId, uniqueId } = useParams<RouteParams>();
  const { selectedWarehouse, allWarehouses, setSelectedWarehouse } =
    useWarehouse();

  const [warehouseData, setWarehouseData] = useState<WarehouseData | null>(
    null
  );

  const [isDataLoaded, setIsDataLoaded] = useState(false);
  const [warehouseInventories, setWarehouseInventories] = useState<
    WarehouseInventoryItem[]
  >([]);
  const [search, setSearch] = React.useState("");
  const [modalOpen, setModalOpen] = useState(false);
  const [modalOpenD, setModalOpenD] = useState(false);
  const [modalOpenI, setModalOpenI] = useState(false);
  const [inputDeliveryData, setInputDeliveryDataData] = useState<
    InputDelivery[]
  >([]);

  const [warehouseInputDeliveryData, setWarehouseInputDeliveryDataData] = useState<
    InputDelivery[]
  >([]);
  const [deliveryOpen, setDeliveryOpen] = React.useState<boolean>(false);
  const [distributions, setDistributions] = useState<Distribution[]>([]);
  const [warehousedistributions, setWarehouseDistributions] = useState<Distribution[]>([]);

  // const [stateCluster, setStateClusters] = React.useState<any[]>([]);

  const [viewModalOpen, setViewModalOpen] = useState<boolean>(false);
  const [selectedDelivery, setSelectedDelivery] =
    useState<InputDelivery | null>(null);

  const [selectedPurchaseOrderId, setSelectedPurchaseOrderId] = useState<
    string | null
  >(null);

  const [stateWarehouse, setStateWarehouse] = React.useState<any>([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [paginationMeta2, setPaginationMeta2] =
    useState<PaginationSecondMeta | null>(null);

  useEffect(() => {
    const loadClusterData = async () => {
      // If we already have the stateId but no clusters, try to fetch them
      if (stateId && stateCluster.length === 0) {
        // Check if we have a saved seasonId (either from context or localStorage)
        const seasonId =
          currentSeasonId || localStorage.getItem("currentSeasonId");

        if (seasonId) {
          console.log(
            `ManageWarehouse: Loading clusters with seasonId: ${seasonId}, stateId: ${stateId}`
          );
          await fetchClustersData(seasonId, stateId);
        } else {
          console.log("No seasonId available to fetch clusters");
        }
      }
    };

    loadClusterData();
  }, [stateId, stateCluster.length, currentSeasonId, fetchClustersData]);

  const fetchInputDistributionData = async () => {
    const result = await getInputDistributionByState(stateId, currentPage, 20);
    if (result) {
      setDistributions(result.data);
      setPaginationMeta2(result.meta);
    }
  };

 
  useEffect(() => {
    const fetchWarehouseData = async () => {
      updateLoader(true, "Fetching warehouse details");

      try {
        if (selectedWarehouse && selectedWarehouse.uniqueId === uniqueId) {
          console.log(
            "Using selected warehouse from context:",
            selectedWarehouse
          );
          setWarehouseData(selectedWarehouse);
          setIsDataLoaded(true);
          updateLoader(false, "");
          return;
        }

        // Next check if it's in the allWarehouses array
        const foundWarehouse = allWarehouses.find(
          (w) => w.uniqueId === uniqueId
        );
        if (foundWarehouse) {
          console.log("Found warehouse in allWarehouses:", foundWarehouse);
          setWarehouseData(foundWarehouse);
          setSelectedWarehouse(foundWarehouse);
          setIsDataLoaded(true);
          updateLoader(false, "");
          return;
        }

        if (uniqueId) {
          const response = await seasonService.getAllWerehouse();
          if (response?.data?.data?.warehouseData) {
            const warehouses = response.data.data.warehouseData;
            const foundWarehouse = warehouses.find(
              (w: any) => w.uniqueId === uniqueId
            );
            if (foundWarehouse) {
              console.log("Found warehouse from API:", foundWarehouse);
              setWarehouseData(foundWarehouse);
              setSelectedWarehouse(foundWarehouse);
              setIsDataLoaded(true);
            } else {
              console.error("Warehouse not found in API response");
              alert.error("Warehouse not found");
            }
          } else {
            console.error("Invalid API response structure:", response);
            alert.error("Failed to load warehouse data - invalid response");
          }
        } else {
          console.error("No uniqueId parameter found in URL");
          alert.error("No warehouse ID specified");
        }
      } catch (error) {
        console.error("Error fetching warehouse:", error);
        alert.error("Failed to load warehouse details");
      } finally {
        updateLoader(false, "");
      }
    };

    const fetchWarehouseInputDeliveryByWarehouseId = async (warehouseUniqueId: string) => {
    updateLoader(true, "Warehouse input delivery by warehouse id");
    try {
      const response = await configService.getInputDeliveryByWarehoseId(warehouseUniqueId);
      if (response && response.data) {
        setWarehouseInputDeliveryDataData(response.data.data || []);
      } else {
        setWarehouseInputDeliveryDataData([]);
      }
    } catch (error) {
      console.error("Error fetching input delivery data:", error);
      alert.error("Failed to fetch input delivery data");
      setWarehouseInputDeliveryDataData([]);
    } finally {
      updateLoader(false, "");
    }
    }

    const fetchWarehouseInputDistributionByWarehouseId = async (warehouseUniqueId: string) => {
    updateLoader(true, "Warehouse inpu distribution by warehouse id");
    try {
      const response = await configService.getInputDistributionBywarehouseId(warehouseUniqueId);
      if (response && response.data) {
        setWarehouseDistributions(response.data.data || []);
      } else {
        setWarehouseDistributions([]);
      }
    } catch (error) {
      console.error("Error fetching input delivery data:", error);
      alert.error("Failed to fetch input delivery data");
      setWarehouseDistributions([]);
    } finally {
      updateLoader(false, "");
    }
    }

    fetchWarehouseData();
    fetchWarehouseInventories(uniqueId);
    fetchInputDeliveryData(parseInt(stateId));
    fetchWarehouseList();
    fetchInputDistributionData();
    fetchWarehouseInputDeliveryByWarehouseId(uniqueId);
    fetchWarehouseInputDistributionByWarehouseId(uniqueId);
  }, [uniqueId, stateId]);

  const fetchWarehouseList = async () => {
    const warehouses = await getWarehousesWithState(
      match.params.stateId,
      1,
      20
    );
    setStateWarehouse(warehouses);
  };

  const fetchWarehouseInventories = async (uniqueId: string) => {
    updateLoader(true, "Fetching Inventories");
    try {
      const response = await configService.getInventoriesByWarehouse(uniqueId);
      console.log("Inventory", response);

      if (response && response.data) {
        console.log("warehouseInventories", warehouseInventories);
        setWarehouseInventories(response.data.data || []);
      } else {
        setWarehouseInventories([]);
      }
    } catch (error) {
      alert.error("Failed to fetch warehouse inventories");
      setWarehouseInventories([]);
    } finally {
      updateLoader(false, "");
    }
  };

  const fetchInputDeliveryData = async (stateId: number) => {
    updateLoader(true, "Fetching Input Delivery Data");
    try {
      // Replace with your actual API call to fetch input delivery data
      const response = await configService.getInputDeliveryByState(stateId);
      if (response && response.data) {
        setInputDeliveryDataData(response.data.data || []);
      } else {
        setInputDeliveryDataData([]);
      }
    } catch (error) {
      console.error("Error fetching input delivery data:", error);
      alert.error("Failed to fetch input delivery data");
      setInputDeliveryDataData([]);
    } finally {
      updateLoader(false, "");
    }
  };

  
  

  //  const fetchInputDeliveryData = async () => {
  //     const result = await getAllInputDeliveryForState(
  //       match.params.stateId,
  //       currentPage,
  //       20
  //     );
  //     if (result) {
  //       console.log("Result ", result);
  //       setInputDeliveryDataData(result.data);
  //       setPaginationMeta(result.meta);
  //     }
  //   };

  const toggle = (tab: string) => {
    if (currentActiveTab !== tab) setCurrentActiveTab(tab);

    if (tab === "2") {
      // fetchInputDeliveryData();
    }
  };

  return (
    <PageBody isLoading={isLoading} message={message}>
      <Layout active="Warehouses">
        <Container className="mt-4 mb-4">
          {warehouseData ? (
            <div className="mb-4">
              <h3></h3>
              <h3>{warehouseData["werehouse name"]}</h3>
            </div>
          ) : (
            <div className="mb-4">
              <h3>Warehouse Details</h3>
              <p className="text-muted">
                {isLoading
                  ? "Loading warehouse information..."
                  : "No warehouse data found"}
              </p>
            </div>
          )}

          <Col sm={12} lg={12}>
            <div>
              <Nav tabs>
                <NavItem>
                  <NavLink
                    className={classnames({
                      active: currentActiveTab === "1",
                    })}
                    onClick={() => {
                      toggle("1");
                    }}
                  >
                    Inventory
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className={classnames({
                      active: currentActiveTab === "2",
                    })}
                    onClick={() => {
                      toggle("2");
                    }}
                  >
                    Input Delivery
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className={classnames({
                      active: currentActiveTab === "3",
                    })}
                    onClick={() => {
                      toggle("3");
                    }}
                  >
                    Input Distribution
                  </NavLink>
                </NavItem>
              </Nav>

              <TabContent activeTab={currentActiveTab}>
                <TabPane tabId="1">
                  <Row>
                    <Col sm="12">
                      <Container className="mt-4">
                        <Table borderless hover responsive striped>
                          <thead>
                            <tr>
                              <th>S/N</th>
                              <th>PRODUCT</th>
                              <th>INSTOCK</th>
                              {/* <th>STATUS</th> */}
                            </tr>
                          </thead>
                          <tbody>
                            {warehouseInventories.length > 0 ? (
                              warehouseInventories.map((item, index) => (
                                <tr key={item.id || index}>
                                  <td>{index + 1}</td>
                                  <td>
                                    <strong>{item.eop?.eopName}</strong>
                                  </td>
                                  <td>{item.totalQuantity}</td>
                                  {/* <td>{item.eop.status}</td> */}
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan={3} className="text-center">
                                  No inventory data available
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </Table>
                      </Container>
                    </Col>
                  </Row>
                </TabPane>

                <TabPane tabId="2">
                  <Row className="mt-3">
                    <Col md={12} className="text-right mb-3">
                      <Button
                        className="btn-create px-4 py-2 shadow bg-or ml-5"
                        onClick={() => setModalOpen(!modalOpen)}
                      >
                        Recieve
                      </Button>
                    </Col>
                  </Row>
                  <Row>
                    <Col sm="12">
                      <Container className="mt-4">
                        <Table borderless hover responsive striped>
                          <thead>
                            <tr>
                              <th>S/N</th>
                              <th>Date</th>
                              <th>Supplier</th>
                              <th>Received Qty</th>
                              <th>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {warehouseInputDeliveryData.map((item, index) => (
                              <tr key={item.id || index}>
                                <td>{index + 1}</td>
                                <td>
                                  {new Date(
                                    item.acceptedDateTime
                                  ).toLocaleDateString()}
                                </td>
                                <td>
                                  {item.purchaseOrderResponseModel.supplierName}
                                </td>
                                <td>
                                  {Array.isArray(item.inputDeliveryDetails) &&
                                    item.inputDeliveryDetails
                                      .slice(0, 2)
                                      .map((deliveryItem, index) => (
                                        <div key={index}>
                                          {deliveryItem.eopName} (Qty:{" "}
                                          {deliveryItem.quantityDelivered})
                                        </div>
                                      ))}
                                  {item.inputDeliveryDetails.length > 2 && (
                                    <div>
                                      + {item.inputDeliveryDetails.length - 2}{" "}
                                      more
                                    </div>
                                  )}
                                </td>
                                <td>
                                  <div className="justify-content-center">
                                    <UncontrolledDropdown className="m-drop">
                                      <DropdownToggle className="m-drop bg-transparent border-0 text-dark font-weight-bold">
                                        <HiDotsVertical />
                                      </DropdownToggle>
                                      <DropdownMenu container="body">
                                        <DropdownItem
                                          onClick={() => {
                                            setSelectedDelivery(item);
                                            setViewModalOpen(true);
                                          }}
                                        >
                                          View Delivery
                                        </DropdownItem>
                                      </DropdownMenu>
                                    </UncontrolledDropdown>
                                  </div>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </Table>
                        <ViewDelivery
                          isOpen={viewModalOpen}
                          toggle={() => setViewModalOpen(!viewModalOpen)}
                          deliveryData={
                            selectedDelivery ? [selectedDelivery] : null
                          }
                        />
                      </Container>
                    </Col>
                  </Row>
                  <WInputDeliveries
                    open={modalOpen}
                    toggle={() => setModalOpen(!modalOpen)}
                    purchaseOrderId={selectedPurchaseOrderId || ""}
                    refreshData={() =>
                      fetchInputDeliveryData(parseInt(stateId))
                    }
                    stateId={parseInt(stateId)}
                    warehouseUniqueId={uniqueId} 
                  />
                </TabPane>

                <TabPane tabId="3">
                  <Row className="mt-3">
                    <Col md={12} className="text-right mb-3">
                      <Button
                        className="btn-create px-4 py-2 shadow bg-or ml-5"
                        onClick={() => setModalOpenI(!modalOpenI)}
                      >
                        Distribute
                      </Button>
                    </Col>
                  </Row>
                  <Row>
                    <Col sm="12">
                      <Container className="mt-4">
                        <Table borderless hover responsive striped>
                          <thead>
                            <tr>
                              <th>S/N</th>
                              <th>Date</th>
                              <th>State</th>
                              <th>Manager</th>
                              <th>Cluster</th>
                              <th>Item</th>
                              <th>Distributed Qty</th>
                            </tr>
                          </thead>
                          <tbody>
                            {warehousedistributions.map((dist, index) => (
                              <tr key={dist.id}>
                                <td>{index + 1}</td>
                                <td>
                                  {new Date(
                                    dist.createdAt
                                  ).toLocaleDateString()}
                                </td>
                                <td>{dist.state}</td>
                                <td>{dist.managerName}</td>
                                <td>{dist.clusterName}</td>
                                <td>{dist.eopName}</td>
                                <td>{dist.distributedQuantity}</td>
                              </tr>
                            ))}
                          </tbody>
                        </Table>
                      </Container>
                    </Col>
                  </Row>
                  <InputDistribution
                    openModal={modalOpenI}
                    toggle={() => setModalOpenI(!modalOpenI)}
                    clusters={stateCluster}
                    warehouses={stateWarehouse}
                    stateId={Number(stateId)}
                    refreshData={fetchInputDistributionData}
                    preselectWarehouseId={uniqueId} 
                  />
                </TabPane>
              </TabContent>
            </div>
          </Col>
        </Container>
      </Layout>
    </PageBody>
  );
};

export default ManageWarehouse;
